import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {VersionsService} from '../../../core/services/versions.service';
import {DIAGRAM_VERSION_STATES_ENUM} from '../models/diagram-version.constant';

export interface IDiagramVersionOpts {
  isReadyToAuthorise?: boolean;
  isAuthorizationActive?: boolean;
}

@Pipe({
  name: 'getVersionName',
  standalone: true
})
export class GetVersionNamePipe implements PipeTransform {
  private ready = this.translateSvc.instant('ASIDE_R.DIAGRAM_STATE_READY');
  private draft = this.translateSvc.instant('ASIDE_R.DIAGRAM_STATE_DRAFT');
  private draftCompleted = this.translateSvc.instant('ASIDE_R.DIAGRAM_STATE_COMPLETED_DRAFT');
  private beingAuthorised = this.translateSvc.instant('ASIDE_R.DIAGRAM_STATE_BEING_AUTHORISED');
  private published = this.translateSvc.instant('ASIDE_R.PUBLISHED_LABEL');
  private archived = this.translateSvc.instant('ASIDE_R.DIAGRAM_STATE_ARCHIVE');
  constructor(
    private translateSvc: TranslateService,
    private versionsSvc: VersionsService
  ) {}

  transform(version: any, isAuthorizationActive?: boolean): string {
    let newName = '';

    switch (version.state) {
      case DIAGRAM_VERSION_STATES_ENUM.READY:
        newName = this.ready;
        break;

      case DIAGRAM_VERSION_STATES_ENUM.DRAFT:
        newName =
          isAuthorizationActive && version.readyToAuthorise ? this.draftCompleted : this.draft;
        break;

      case DIAGRAM_VERSION_STATES_ENUM.BEING_AUTHORISED:
        newName = this.beingAuthorised;
        break;

      case DIAGRAM_VERSION_STATES_ENUM.ARCHIVE:
        newName = this.archived;
        break;

      case DIAGRAM_VERSION_STATES_ENUM.MASTER:
        newName = this.published;
        break;

      default:
        newName = version.name;
    }

    return newName;
  }
}
